import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Space, Typography } from 'antd';
import firebase from 'firebase';
import React, { FC, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { t } from '../api/calls';
import { login, updateEmail, updatePassword } from '../api/calls/auth';
const { Paragraph } = Typography;

export type ProfileModalProps = {
  visible: boolean;
  onCancel: () => void;
};

export const ProfileModal: FC<ProfileModalProps> = ({ visible, onCancel }) => {
  const [user] = useAuthState(firebase.auth());
  const [newEmail, setNewEmail] = useState(null); // have to to this because above line does not update on email update

  const passwordSubmitHandler = async (values) => {
    await login(user?.email, values.password);
    await updatePassword(values.newPassword);
  };

  const emailSubmitHandler = async (values) => {
    await login(user?.email, values.password);
    await updateEmail(values.email);
    setNewEmail(values.email);
  };

  const emailModal = () =>
    Modal.confirm({
      title: t('changeLoginEmail'),
      okButtonProps: { style: { display: 'none' } },
      content: (
        <div style={{ marginTop: 24 }}>
          <Form onFinish={emailSubmitHandler} layout="vertical">
            <Form.Item
              label={t('currentPassword')}
              name="password"
              rules={[{ required: true, message: t('passwordInvalid') }]}>
              <Input id="newPassword" type="password" placeholder={t('currentPassword')} prefix={<LockOutlined />} />
            </Form.Item>
            <Form.Item
              label={t('newEmail')}
              name="email"
              rules={[{ required: true, message: t('emailInvalid'), type: 'email' }]}>
              <Input type="email" placeholder={t('newEmail')} prefix={<UserOutlined />} />
            </Form.Item>
            <Button type="primary" ghost htmlType="submit">
              {t('change')}
            </Button>
          </Form>
        </div>
      ),
    });

  const passwordModal = () =>
    Modal.confirm({
      title: t('changePassword'),
      okButtonProps: { style: { display: 'none' } },
      content: (
        <div style={{ marginTop: 24 }}>
          <Form onFinish={passwordSubmitHandler} layout="vertical">
            <Form.Item
              label={t('currentPassword')}
              name="password"
              rules={[{ required: true, message: t('passwordInvalid') }]}>
              <Input id="newPassword" type="password" placeholder={t('currentPassword')} prefix={<LockOutlined />} />
            </Form.Item>
            <Form.Item
              label={t('newPassword')}
              name="newPassword"
              rules={[{ required: true, message: t('passwordInvalid') }]}>
              <Input id="password" type="password" placeholder={t('newPassword')} prefix={<LockOutlined />} />
            </Form.Item>
            <Button type="primary" ghost htmlType="submit">
              {t('change')}
            </Button>
          </Form>
        </div>
      ),
    });

  return (
    <Modal
      title={t('loginSettings')}
      okButtonProps={{ style: { display: 'none' } }}
      onCancel={onCancel}
      visible={visible}>
      <Space direction="vertical" size="small">
        <Space direction="horizontal" size="small">
          <Paragraph>{t('email')}: </Paragraph>
          <Paragraph code>{newEmail ?? user?.email}</Paragraph>
        </Space>
        <Button onClick={emailModal}>{t('changeLoginEmail')}</Button>
        <Button onClick={passwordModal}>{t('changePassword')}</Button>
      </Space>
    </Modal>
  );
};
